module.exports = __webpack_public_path__ + "static/media/home_arrow_bottom.d36f09e7.svg";